module.exports = __webpack_public_path__ + "img/CONTACT_FORM.c1015aa1.svg";